export const XHR_BASE_PATH = '/_napi/da-sisu/';
export const API_BASE_PATH = `${XHR_BASE_PATH}api`;
export const SHARED_API_BASE_PATH = `${XHR_BASE_PATH}shared_api`;

export const PROVIDER_GOOGLE = 4;
export const PROVIDER_FACEBOOK = 2;
export const PROVIDER_WIX = 6;

export const COMPLETE_REDIRECT_FORM_ID = 'complete-redirect-form';
